const timezones = {
	fr: {
		PST: 'HNP', // Heure Normale du Pacifique
		PDT: 'HAP', // Heure Avancée du Pacifique
		MST: 'HNR', // Heure Normale des Rocheuses
		MDT: 'HAR', // Heure Avancée des Rocheuses
		CST: 'HNC', // Heure Normale du Centre
		CDT: 'HAC', // Heure Avancée du Centre
		EST: 'HNE', // Heure Normale de l'Est
		EDT: 'HAE', // Heure Avancée de l'Est
		AST: 'HNA', // Heure Normale de l'Atlantique
		ADT: 'HAA', // Heure Avancée de l'Atlantique
		NST: 'HNT', // Heure Normale de Terre-Neuve
		NDT: 'HAT'  // Heure Avancée de Terre-Neuve
	}
}

export default timezones;